import Loading from 'components/ui/Loader'
import { ReactNode } from 'react'
import clsx from 'clsx'

export interface DialogBodyProps {
  children: ReactNode
  isLoading?: boolean
  className?: string
}

const DialogBody: React.FC<DialogBodyProps> = ({
  children,
  isLoading = false,
  className
}) => {
  return (
    <div className={clsx("mt-6 relative", className)}>
      {children}
      <Loading loading={isLoading}></Loading>
    </div>
  )
}

export default DialogBody
